import styled from "styled-components";
import { motion } from "framer-motion";

const InviteText = ({ header1, header2, para }) => {
  return (
    <IntroText>
      <h2>{header1}</h2>

      {header2 && <h2>Build you wealth faster.</h2>}

      <p>{para}</p>
    </IntroText>
  );
};

const IntroText = styled(motion.div)`
  color: white;
  padding-right: 25rem;
  padding-left: 3rem;

  h2,
  h3,
  p {
    white-space: normal;
    font-family: "Roboto", "Arial";
  }

  h2 {
    font-size: 3.3rem;
    font-weight: bold;

    @media (max-width: 1024px) {
      font-size: 2.5rem;
    }
  }

  p {
    font-size: 1.1rem;
    padding-top: 1.5rem;

    @media (max-width: 1024px) {
      font-size: 0.9rem;
    }
  }

  @media (max-width: 1400px) {
    padding-right: 5rem;
  }

  @media (max-width: 1024px) {
    padding-right: 3rem;
  }

  @media (max-width: 901px) {
    text-align: center;
  }
`;
export default InviteText;
